/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Cass from 'astro/server/sector/cass';
import Neighbors from 'astro/server/sector/neighbors';
import Zones from 'astro/server/sector/zones';


export default class
{
  constructor (cass, planet)
  {
    this.planet = planet;

    this.cass = new Cass(cass);
    this.zones = new Zones(this);
    this.neighbors = new Neighbors(this);
  }


  getNeighbors ()
  {
    return this.neighbors;
  }


  getTransfers ()
  {
    return this.transfers;
  }


  getZones ()
  {
    return this.zones;
  }


  getPlanet ()
  {
    return this.planet;
  }


  getUser ()
  {
    return this.planet.getUser(this.getCass().getUser());
  }


  getBuilding ()
  {
    return this.planet.getBuilding(this.getCass().getCenter().toString());
  }


  getConstants ()
  {
    return this.planet.getConstants().getGeneral();
  }


  getID ()
  {
    return this.cass.getID();
  }


  getCass ()
  {
    return this.cass;
  }


  // TODO remove ?
  getEnemyUnits (userID)
  {
    let units = [];

    const zones = this.getZones();
    const planet = this.getPlanet();

    zones.eachZone(zone =>
    {
      zone.getAttributes().eachInfluence(influence =>
      {
        if (influence.getType() === InfluenceEnum.Attack)
        {
          if (influence.getUserID() === userID)
          {
            const { id, parent } = influence.getSource();

            if (parent.id === planet.getID())
            {
              units.push(planet.getUnit(id));
            }
          }
        }
      });
    });

    return Array.unique(units);
  }


}
